import { LANGUAGES_LIST } from '../constants';

export const PREFERRED_LANG_KEY = '_preferredLang';

export const getStoredLanguage = () => {
  try {
    const stored = localStorage.getItem(PREFERRED_LANG_KEY);
    if (LANGUAGES_LIST.indexOf(stored) !== -1) {
      return stored;
    }
  } catch (e) {
    // Ignore storage access errors (private mode, etc.)
  }

  const browserLang = (typeof navigator !== 'undefined'
    && (navigator.language || navigator.userLanguage)
    || 'en').toLowerCase();
  return browserLang.indexOf('es') === 0 ? 'es' : 'en';
};

export const persistLanguage = (lang) => {
  if (LANGUAGES_LIST.indexOf(lang) === -1) {
    return;
  }
  try {
    localStorage.setItem(PREFERRED_LANG_KEY, lang);
  } catch (e) {
    // Ignore storage access errors
  }
};
